{
  "checkEmailMessage": "Wenn sich {{email}} registrieren lässt, haben wir einen Link dorthin gesendet. Öffnen Sie ihn innerhalb von 30 Minuten, um die Adresse zu bestätigen.",
  "checkEmailTitle": "Sehen Sie in Ihr Postfach",
  "closed": "Diese Installation legt Konten nur auf Einladung an. Fragen Sie eine Administratorin oder einen Administrator.",
  "intro": "Wir senden einen Link an Ihre E-Mail-Adresse. Öffnen Sie ihn, um die Adresse zu bestätigen.",
  "noEmailDelivery": "Diese Installation versendet keine E-Mails. Bitten Sie den Betreiber, den E-Mail-Versand für die Bestätigung einzurichten.",
  "resend": "Link erneut senden",
  "resent": "Wenn die Adresse auf ihre Bestätigung wartet, ist ein neuer Link unterwegs.",
  "submit": "Konto anlegen",
  "title": "Konto anlegen"
}
